/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Api_Keys_Name_Too_LongInputs */

const vi_api_keys_name_too_long = /** @type {(inputs: Api_Keys_Name_Too_LongInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tên khóa tối đa ${i?.max} ký tự — rút gọn lại.`)
};

/**

* @param {Api_Keys_Name_Too_LongInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const api_keys_name_too_long = /** @type {((inputs: Api_Keys_Name_Too_LongInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Keys_Name_Too_LongInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_api_keys_name_too_long(inputs)
});